export default __webpack_public_path__ + "static/media/cnt.67cf0e9d.png";